import React, { useRef, useEffect } from "react";
import { createPortal } from "react-dom";

import { SidebarContainer, CloseButton } from "./SidebarStyles";

function SidebarSenasaElectronic(props) {
  const { children } = props;
  const elRef = useRef(null);
  if (!elRef.current) {
    const div = document.createElement("div");
    elRef.current = div;
  }

  useEffect(() => {
    const sidebarRoot = document.getElementById("sidebar");
    sidebarRoot.appendChild(elRef.current);
    return () => sidebarRoot.removeChild(elRef.current);
  }, []);

  const outsideClick = () => {
    if (props.onOutsideClick != null) {
      props.onOutsideClick();
    }
  };

  return createPortal(
    <SidebarContainer left={props.left} zIndex={props.zIndex}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        onKeyDown={() => {}}
        role="button"
        className="children-container"
      >
        <CloseButton>
          <button onClick={outsideClick}>X</button>
        </CloseButton>
        {children}
      </div>
    </SidebarContainer>,
    elRef.current
  );
}

export default SidebarSenasaElectronic;
